import { Inject, Injectable, Injector } from '@angular/core';



@Injectable({ providedIn: 'root' })
export class TransloadOrders_ReportService {

  constructor(
    private injector: Injector
  ) {
  }

  public TransloadOrders: TransloadOrders_ReportService = this;

  // injecting lazily in order to avoid circular dependencies
}

